import { render } from "./NoView.vue?vue&type=template&id=1f3c8b18"
import script from "./NoView.vue?vue&type=script&lang=js"
export * from "./NoView.vue?vue&type=script&lang=js"

import exportComponent from "/agent/_work/1/s/GiftCards/giftcard_vuejs_src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__